/* eslint-disable */
// The 7 lens families (brief §2.3 — exactly these; "Paper transfer" excluded everywhere).
// g = [dark, mid, light] glass-lens tint stops (visual-parity brief §3). tint (single) = g[1]
// for the small nav/banner dots. nw = the near-white gradient BOTTOM stop for the flat-glass
// lens (redesign 2026-07-02, Option B): --t0=g[0], --t1=g[1], --t2=nw. Values for the 4 families
// in the prototype's tint classes are copied VERBATIM; the other 3 use a matching faint-hue
// near-white so the bottom reads white with a whisper of the family colour.
// Order (§8): BLACK + Brown are the two biggest sellers → first and adjacent.
// `label` is display-only; `id` stays the stored DB value (BLK) so the sync is unaffected (§5).
export const FAMILIES = [
  { id: 'BLK', label: 'Black', line: 'Black & smoke lenses', g: ['#2c2824', '#6d675e', '#cbc5ba'], nw: '#fdfdfc' },
  { id: 'Brown', label: 'Brown', line: 'Browns, taupe & tan', g: ['#37220f', '#7d5330', '#dcc6ad'], nw: '#fdfcfa' },
  { id: 'Blue', label: 'Blue', line: 'Blues, oceans & ice tones', g: ['#1c3a5e', '#3d6ea5', '#bcd6ee'], nw: '#fbfdff' },
  { id: 'Green', label: 'Green', line: 'Greens, olive & emerald', g: ['#1f4531', '#3f8a5c', '#bfe3cb'], nw: '#fbfefc' },
  { id: 'Purple', label: 'Purple', line: 'Purples, violet & plum', g: ['#3a2757', '#7856a0', '#dcccef'], nw: '#fdfbff' },
  { id: 'Pink', label: 'Pink', line: 'Pinks, rose & blush', g: ['#742c46', '#c67a97', '#f3d8e2'], nw: '#fffbfd' },
  { id: 'Orange\\Yellow', label: 'Orange / Yellow', line: 'Oranges, amber & yellow', g: ['#8a5410', '#dd9a34', '#f8e3b2'], nw: '#fffdf7' },
].map((f) => ({ ...f, tint: f.g[1] }));
export const FAMILY_IDS = FAMILIES.map((f) => f.id);
export const familyMeta = (id) => FAMILIES.find((f) => f.id === id) || { id, label: id, line: '', g: ['#6d675e', '#9a8e80', '#cbc5ba'], nw: '#fdfdfc', tint: '#9a8e80' };
export const EXCLUDED_FAMILY = 'Paper transfer';

// The Yaeli orb tint — neutral graphite/silver glass with a white star (§7).
export const YAELI_G = ['#4c4a47', '#8c8884', '#ded9d1'];
export const YAELI_NW = '#fdfdfc';
export const YAELI_FC = '#8c8884';
export const BEST_G = ['#c98a2a', '#e0a844', '#f6dca0'];   // amber glass for the Best Sellers banner/chip
export const BEST_NW = '#fffdf6';

export const COLLECTIONS = [
  { id: '__best', label: 'Best Sellers', line: 'Top lenses by units sold', tint: '#d4af37' },
  { id: '__yaeli', label: 'Yaeli Favorites', line: "Yaeli's hand-picked selection", tint: YAELI_FC },
];
